import React from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";

const CHIP_SX = {
  height: 22,
  fontSize: "11px",
  fontWeight: 600,
  backgroundColor: "#E0E7FF",
  color: "#3730A3",
  "& .MuiChip-deleteIcon": { fontSize: 14, color: "#6366F1" },
};

/**
 * Chip-style tag editor. `freeSolo` (default) lets the user type new tags;
 * set it to false to restrict selection to `options` (e.g. a filter).
 */
const TagsInput = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Add tag",
  freeSolo = true,
  inputSx = {},
  sx = {},
  ...rest
}) => (
  <Autocomplete
    multiple
    size="small"
    freeSolo={freeSolo}
    autoHighlight
    options={options}
    value={Array.isArray(value) ? value : []}
    onChange={(_, next) => onChange?.(next)}
    renderTags={(tags, getTagProps) =>
      tags.map((tag, index) => (
        <Chip {...getTagProps({ index })} key={`${tag}-${index}`} label={tag} size="small" sx={CHIP_SX} />
      ))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder={value.length === 0 ? placeholder : ""}
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            fontSize: "12px",
            py: "2px !important",
            "& fieldset": { borderColor: "#E2E8F0" },
            "&:hover fieldset": { borderColor: "#CBD5E1" },
            "&.Mui-focused fieldset": { borderColor: "#3B82F6" },
          },
          "& .MuiAutocomplete-input": { fontSize: "12px", py: "3px !important" },
          ...inputSx,
        }}
      />
    )}
    sx={sx}
    {...rest}
  />
);

export default TagsInput;
